import { useSelector } from 'react-redux';

import { pageNames } from '@atc/bonnet-paths';
import { useFeatures } from '@atc/features';

import useIsIndexable from '@/utilities/useIsIndexable';

import srpContentDuck from '@/ducks/srp/srpContentDuck';
import srpLocationTypeDuck from '@/ducks/srp/srpLocationTypeDuck';
import srpResultsDuck from '@/ducks/srp/srpResultsDuck';
import srpSupplementalDuck from '@/ducks/srp/srpSupplementalDuck';

import CanonicalUrlModule from '@/modules/CanonicalUrlModule';

const { SEARCH_RESULTS } = pageNames;

export default function useCustomContent(pageName = SEARCH_RESULTS) {
    const {
        enable_srp_altezza_custom_content: [enableAltezzaCustomContent],
    } = useFeatures([
        'enable_srp_altezza_custom_content',
    ]);

    const isEnableCustomContent = useSelector(srpContentDuck.selectors.isEnableCustomContent);
    const customContent = useSelector(srpContentDuck.selectors.getCustomContent);
    const resultsCount = useSelector(srpResultsDuck.selectors.getResultsCount);
    const isNational = useSelector(srpLocationTypeDuck.selectors.getDuckState);
    const supplementalCount = useSelector(srpSupplementalDuck.selectors.getResultCount);
    const canonicalUrl = useSelector(CanonicalUrlModule.duck.selectors.getDuckState);
    const isIndexable = useIsIndexable(canonicalUrl, pageName);

    return {
        isEnableCustomContent: isNational && enableAltezzaCustomContent && isEnableCustomContent && isIndexable
            && resultsCount === 0 && supplementalCount === 0,
        canonicalUrl,
        isIndexable,
        customContent,
    };
}
